import { queryOptions } from '@tanstack/react-query'

import { getShipmentEmissions } from './shipments.service'

export const shipmentEmissionsQueryOptions = (shipmentId: string) =>
  queryOptions({
    queryKey: ['emissions', shipmentId],
    queryFn: async () => getShipmentEmissions(shipmentId),
  })
